import team_section_card_img from "../../../../../public_images/Teammembercard.svg";
import team_section_card_one from "../../../../assets/img/Team-Section-Card-1.svg";
import team_section_avatar from "../../../../assets/img/icn/icn-Config.svg";
import twiter_icon from "../../../../assets/img/icn/icn-card-twitter-x.svg";
import facebook_icon from "../../../../assets/img/icn/icn-card-facebook.svg";
import linkedin_icon from "../../../../assets/img/icn/icn-card-linkdin.svg";
import telegram_icon from "../../../../assets/img/icn/icn-card-telegram.svg";

export default {
  title: 'Components/DDA Cards/DDA Team Section Cards/Team Section Card',
  tags: ['autodocs'],
  argTypes: {
    image_src: {
      control: 'text',
      description: 'Path to the image of the team member',
    },
    header_text: {
      control: 'text',
      description: 'Header text for the information card',
    },
    profession: {
      control: 'text',
      description: 'Profession for the information card',
    },
    body_text: {
      control: 'text',
      description: 'Body text for the information card',
    },
    body_text_two: {
      control: 'text',
      description: 'Body text for the information card',
    },
    custom_class: {
      control: { type: 'text' },
      description: 'Custom class for the credit card component',
    },
    component_mode: {
      control: { type: 'check' },
      options: ['light-mode'],
      description: 'Mode of the credit card component',
    },
    card_type: {
      control: { type: 'text' }
    },
    social_icons: {
      control: 'object',
      description: 'Array of social media icon links (only used in variant-three)',
    },
  },
  parameters: {
    docs: {
      description: {
        component: `
To use the \`dda-teamsection-card\` component, pass the following props:

\`\`\`html
<dda-teamsection-card
  image_src="https://example.com/image.jpg"
  header_text="Jeffery Walker"
  body_text="Team Lead"
  card_type="variant-three"
  social_icons='[
    {
      "SocialLink": "#",
      "SocialLinkTitle": "Twitter",
      "SocialIconSrc": "assets/img/icn/icn-card-twitter-x.svg",
      "SocialIconAlt": "Twitter Icon",
      "SocialIconText": "Twitter"
    }
  ]'
></dda-teamsection-card>
\`\`\`
        `,
      },
    },
  },
};

const Template = (args) => {
  const { social_icons, ...rest } = args;

  const attributes = Object.entries(rest)
    .filter(([key, value]) => value !== undefined && key !== 'text')
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ');

  const socialIconsAttr = social_icons ? ` social_icons='${JSON.stringify(social_icons)}'` : '';

  return `<dda-teamsection-card ${attributes}${socialIconsAttr}></dda-teamsection-card>`;
};

export const VariantOne = Template.bind({});
VariantOne.args = {
  image_src: team_section_card_img,
  header_text: "Jeffery Walker",
  body_text: "Cloud Architect",
  custom_class: 'dda-w-50 my-custom-class',
  component_mode: '',
  card_type: "variant-one"
};

export const VariantTwo = Template.bind({});
VariantTwo.args = {
  image_src: team_section_card_img,
  header_text: "Jeffery Walker",
  body_text: "CEO",
  custom_class: 'dda-w-50 my-custom-class',
  component_mode: '',
  card_type: "variant-two"
};

export const VariantThree = Template.bind({});
VariantThree.args = {
  image_src: team_section_card_img,
  header_text: "Jeffery Walker",
  body_text: "CEO",
  custom_class: 'dda-w-50 my-custom-class',
  component_mode: '',
  card_type: "variant-three",
  social_icons: [
    {
      SocialLink: "#",
      SocialLinkTitle: "Twitter",
      SocialIconSrc: twiter_icon,
      SocialIconAlt: "Twitter Icon",
      SocialIconText: "Twitter",
    },
    {
      SocialLink: "#",
      SocialLinkTitle: "Facebook",
      SocialIconSrc: facebook_icon,
      SocialIconAlt: "Facebook Icon",
      SocialIconText: "Facebook",
    },
    {
      SocialLink: "#",
      SocialLinkTitle: "Linkedin",
      SocialIconSrc: linkedin_icon,
      SocialIconAlt: "Linkedin Icon",
      SocialIconText: "Linkedin",
    },
    {
      SocialLink: "#",
      SocialLinkTitle: "Telegram",
      SocialIconSrc: telegram_icon,
      SocialIconAlt: "Telegram Icon",
      SocialIconText: "Telegram",
    },
  ]
};

export const VariantFour = Template.bind({});
VariantFour.args = {
  image_src: team_section_card_one,
  header_text: "Jeffery Walker",
  profession: "UI / UX Designer",
  body_text: "Lisa's proactive support and problem-solving abilities make her an invaluable advocate for our customers.",
  custom_class: 'my-custom-class',
  component_mode: '',
  card_type: "variant-four",
  social_icons: [
    {
      SocialLink: "#",
      SocialLinkTitle: "Twitter",
      SocialIconSrc: twiter_icon,
      SocialIconAlt: "Twitter Icon",
      SocialIconText: "Twitter",
    },
    {
      SocialLink: "#",
      SocialLinkTitle: "Facebook",
      SocialIconSrc: facebook_icon,
      SocialIconAlt: "Facebook Icon",
      SocialIconText: "Facebook",
    },
    {
      SocialLink: "#",
      SocialLinkTitle: "Linkedin",
      SocialIconSrc: linkedin_icon,
      SocialIconAlt: "Linkedin Icon",
      SocialIconText: "Linkedin",
    },
    {
      SocialLink: "#",
      SocialLinkTitle: "Telegram",
      SocialIconSrc: telegram_icon,
      SocialIconAlt: "Telegram Icon",
      SocialIconText: "Telegram",
    },
  ]
};

export const VariantFive = Template.bind({});
VariantFive.args = {
  image_src: team_section_card_img,
  header_text: "Jeffery Walker",
  body_text: "Cloud Architect",
  custom_class: 'dda-w-50 my-custom-class',
  component_mode: '',
  card_type: "variant-five"
};

export const VariantSix = Template.bind({});
VariantSix.args = {
  image_src: team_section_avatar,
  header_text: "Jeffery Walker",
  body_text: "Cloud Architect",
  custom_class: 'my-custom-class',
  component_mode: '',
  card_type: "variant-six"
};

export const VariantSeven = Template.bind({});
VariantSeven.args = {
  image_src: team_section_avatar,
  header_text: "Jeffery Walker",
  body_text: "Cloud Architect",
  custom_class: 'my-custom-class',
  component_mode: '',
  card_type: "variant-seven"
};

export const VariantEight = Template.bind({});
VariantEight.args = {
  image_src: team_section_avatar,
  header_text: "Jeffery Walker",
  body_text: "Cloud Architect",
  body_text_two: "An ambitious and exquisite personality that always strives to exceed expectations. Always there when someone is in need.",
  custom_class: 'image-rounded',
  component_mode: '',
  card_type: "variant-eight"
};
